// extracted by mini-css-extract-plugin
module.exports = {"logoIcon":"ssj1ldKrp+tXiJkkvnRTqg==","headerDetails":"FzEZgCx4Tya4OeUIOabOYw==","planName":"_8fanYOLZx+PMB8DxY6D7HQ==","valueBadge":"jNczp-YOK6E2Z6vwqSJhrQ=="};